export default function Skills() {
    return (
        <div id="Skills" className="skills">
            <h1 className="text-center" >Skills</h1>
            <br />
            <ul data-aos="fade-up" data-aos-duration="2000">
                <li>
                    <b>Programming languages:</b> C, C++, Java, JavaScript, Python.
                </li>
                <li>
                    <b>Web Development: </b>HTML, CSS, React, Bootstrap, Django.
                </li>
                <li>
                    <b>App Development: </b>Java, React-native.
                </li>
                <li>
                    <b>Database: </b>  SQL, Firebase, DynamoDB.
                </li>
                <li>
                    <b>Tools:</b> Git, Postman, Jira, Maven, Gradle.
                </li>
            </ul>
        </div>
    )
}
